import { render, staticRenderFns } from "./pickMem.vue?vue&type=template&id=b6fa44b2&"
import script from "./pickMem.vue?vue&type=script&lang=js&"
export * from "./pickMem.vue?vue&type=script&lang=js&"
import style0 from "./pickMem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports